var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"root-support-button",on:{"click":_vm.handleClick}},[(_vm.isZendeskLoading)?_c('spinner',{staticClass:"spinner",attrs:{"theme":"light","size":"24"}}):_c('span',{staticClass:"mark"},[_vm._v("?")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }